export const getAuthTokens = () => {
  const authToken = localStorage.getItem('authToken');
  const refreshToken = localStorage.getItem('refreshToken');

  return { authToken, refreshToken };
};

export const setAuthToken = (accessToken, refreshToken) => {
  localStorage.setItem('authToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
};

export const clearAuthToken = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('refreshToken');
};

export const getAuthEmail = () => {
  const email = localStorage.getItem('authEmail');
  return email || '';
};

export const setAuthEmail = (email) => {
  localStorage.setItem('authEmail', email);
};

export const clearAuthEmail = () => {
  localStorage.removeItem('authEmail');
};

export const getAuthInitials = () => {
  return localStorage.getItem('authInitials');
};

export const setAuthInitials = (initials) => {
  localStorage.setItem('authInitials', initials);
};

export const clearAuthInitials = () => {
  localStorage.removeItem('authInitials');
};

export const setSelectedRole = (role) => {
  localStorage.setItem('selectedRole', role);
};

export const getSelectedRole = () => {
  const role = localStorage.getItem("selectedRole");
  return role ? { selectedRole: role } : null;
};


export const clearSelectedRole = () => {
  localStorage.removeItem('selectedRole');
};